(function () {
    'use strict';

    angular.module("imApp").factory("p2TableService", ['$ihttp', function ($ihttp) {
        let service = {
            listTables: function (parms) {
                return $ihttp.post({
                    method: 24,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
